import { OperatorPriceChangesService, type OperatorPriceChangeLogAdminDto } from '@/backend/market'
import { PaginateEntity } from '@/shared/entities/PaginateEntity'
import { OperatorPriceChangeFilterModel } from '../models/OperatorPriceChangeFilterModel'
import { OperatorPriceChangeLogModel } from '../models/OperatorPriceChangeLogModel'
import type { OperatorPriceChangeFilterEntity } from '../../domain/entities/OperatorPriceChangeFilterEntity'
import type { OperatorPriceChangeLogEntity } from '../../domain/entities/OperatorPriceChangeLogEntity'
import { OperatorPriceChangeRepository } from '../../domain/repositories/OperatorPriceChangeRepository'

export class OperatorPriceChangeRepositoryImpl implements OperatorPriceChangeRepository {
  async getOperatorPriceChanges(
    filterData: OperatorPriceChangeFilterEntity
  ): Promise<PaginateEntity<OperatorPriceChangeLogEntity[]> | { error: true }> {
    const filterModel = new OperatorPriceChangeFilterModel(filterData)

    try {
      const response = await OperatorPriceChangesService.getOperatorPriceChangesAdmin(filterModel)
      const logs = response.items?.map(
        (item: OperatorPriceChangeLogAdminDto) => new OperatorPriceChangeLogModel(item)
      )

      return new PaginateEntity<OperatorPriceChangeLogModel[]>(response, logs)
    } catch {
      return { error: true }
    }
  }
}
